/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Starting_Work_OrderInputs */

const en_work_order_import_status_starting_work_order = /** @type {(inputs: Work_Order_Import_Status_Starting_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting work order import... Please wait.`)
};

const fr_work_order_import_status_starting_work_order = /** @type {(inputs: Work_Order_Import_Status_Starting_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de l’importation de l’ordre de travail... Veuillez patienter.`)
};

const de_work_order_import_status_starting_work_order = /** @type {(inputs: Work_Order_Import_Status_Starting_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsauftragsimport wird gestartet... Bitte warten.`)
};

const it_work_order_import_status_starting_work_order = /** @type {(inputs: Work_Order_Import_Status_Starting_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio dell'importazione dell'ordine di lavoro... Attendere prego.`)
};

const ru_work_order_import_status_starting_work_order = /** @type {(inputs: Work_Order_Import_Status_Starting_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинается импорт заказов на выполнение работ... Пожалуйста, подождите.`)
};

const es_work_order_import_status_starting_work_order = /** @type {(inputs: Work_Order_Import_Status_Starting_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando importación de orden de trabajo... Por favor espere.`)
};

const zh_cn2_work_order_import_status_starting_work_order = /** @type {(inputs: Work_Order_Import_Status_Starting_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入工单……请稍候。`)
};

const ja_work_order_import_status_starting_work_order = /** @type {(inputs: Work_Order_Import_Status_Starting_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業指示書のインポートを開始しています... お待ちください。`)
};

const hi_work_order_import_status_starting_work_order = /** @type {(inputs: Work_Order_Import_Status_Starting_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्य आदेश आयात शुरू हो रहा है... कृपया प्रतीक्षा करें।`)
};

const pt_pt2_work_order_import_status_starting_work_order = /** @type {(inputs: Work_Order_Import_Status_Starting_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a importação da ordem de serviço... Aguarde.`)
};

/**
* | output |
* | --- |
* | "Starting work order import... Please wait." |
*
* @param {Work_Order_Import_Status_Starting_Work_OrderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_starting_work_order = /** @type {((inputs?: Work_Order_Import_Status_Starting_Work_OrderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Starting_Work_OrderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_status_starting_work_order(inputs)
	if (locale === "de") return de_work_order_import_status_starting_work_order(inputs)
	if (locale === "it") return it_work_order_import_status_starting_work_order(inputs)
	if (locale === "ru") return ru_work_order_import_status_starting_work_order(inputs)
	if (locale === "es") return es_work_order_import_status_starting_work_order(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_status_starting_work_order(inputs)
	if (locale === "ja") return ja_work_order_import_status_starting_work_order(inputs)
	if (locale === "hi") return hi_work_order_import_status_starting_work_order(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_status_starting_work_order(inputs)
	return en_work_order_import_status_starting_work_order(inputs)
});